/* src/app/shared/spinner/spinner.component.scss */
.spinner {
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
  display: inline-block;
}
.spinner.size-xs {
  width: 10px;
  height: 10px;
  border-width: 1.5px;
  border-style: solid;
}
.spinner.size-sm {
  width: 15px;
  height: 15px;
  border-width: 2px;
  border-style: solid;
}
.spinner.size-md {
  width: 22px;
  height: 22px;
  border-width: 2px;
  border-style: solid;
}
.spinner.size-lg {
  width: 32px;
  height: 32px;
  border-width: 3px;
  border-style: solid;
}
.spinner.color-primary {
  border-color: rgba(255, 195, 0, 0.15);
  border-top-color: var(--primary);
}
.spinner.color-white {
  border-color: rgba(255, 255, 255, 0.15);
  border-top-color: #ffffff;
}
.spinner.color-danger {
  border-color: rgba(239, 68, 68, 0.15);
  border-top-color: var(--danger-text-hover);
}
.spinner.color-success {
  border-color: var(--success-hover);
  border-top-color: var(--success);
}
.spinner.color-muted {
  border-color: rgba(255, 255, 255, 0.08);
  border-top-color: rgba(255, 255, 255, 0.4);
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=spinner.component-RIILSW67.css.map */
